import React, { useEffect, useState } from "react";
import GeneralTable from "../../components/Table/GeneralTable";
import axiosInstance from "../../axiosInstance"; // Import your Axios instance

function Fallback() {
  const [tableData, setTableData] = useState([]); // Initialize as empty array

  useEffect(() => {
    const fetchFallbackData = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_MANAGER_URL}/leave-history/fallback`
        );

        if (response.data.status === 200) {
          // Transform the fetched data into the format needed for the table
          const formattedData = response.data.data.map((item) => ({
            fromDate: item.leaveDates[0], // Example: get the first leave date as fromDate
            toDate: item.leaveDates[item.leaveDates.length - 1], // Last leave date as toDate
            fallbackFrom: item.fallbackFrom,
            fallbackTo: item.fallbackTo,
            responsibility: item.responsibility,
          }));

          setTableData(formattedData);
        } else {
          console.error("Failed to fetch data:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching fallback data:", error);
      }
    };

    fetchFallbackData();
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div className="fallback-container">
      <h1 className="display6">Team Fallback</h1>

      {/* General Table */}
      <GeneralTable
        columns={[
          { header: "From Date", accessor: "fromDate" },
          { header: "To Date", accessor: "toDate" },
          { header: "Fallback From", accessor: "fallbackFrom" },
          { header: "Fallback To", accessor: "fallbackTo" },
          { header: "Responsibility", accessor: "responsibility" },
        ]}
        data={tableData}
        title="Manage Fallback"
      />
    </div>
  );
}

export default Fallback;
